import React, { useMemo } from 'react';
import { useStore } from '../../contexts/StoreContext';
import { bodyTypes, downBudgets, monthlyBudgets, priceBudgets, segments, termOptions } from '../../data/options';
import { CatalogFilters as Filters, emptyFilters } from '../../utils/catalog';
interface Props {
  filters: Filters;
  onChange: (f: Filters) => void;
}
export function CatalogFilters({
  filters,
  onChange
}: Props) {
  const {
    brands,
    vehicles
  } = useStore();
  const models = useMemo(() => Array.from(new Set(vehicles.filter(v => v.published && (!filters.brand || v.brandId === filters.brand)).map(v => v.model))).sort(), [vehicles, filters.brand]);
  const set = <K extends keyof Filters,>(k: K, v: Filters[K]) => onChange({
    ...filters,
    [k]: v,
    ...(k === 'brand' ? {
      model: ''
    } : {})
  });
  const selectRow = (id: string, label: string, value: string | number, opts: {
    label: string;
    value: string | number;
  }[], key: keyof Filters, numeric?: boolean) => <div data-id="element-416" data-mp="q4uxrjcxos6h">
      <label htmlFor={id} className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-silver" data-id="element-417" data-mp="2preye037srt2">{label}</label>
      <select id={id} className="input-silver" value={value} onChange={e => set(key, (numeric ? Number(e.target.value) : e.target.value) as never)} data-id="element-418" data-mp="2tsgzkmgozdxo">
        <option value={numeric ? 0 : ''} data-id="element-419" data-mp="33qwoqjw5sd4j">Todos</option>
        {opts.map(o => <option key={String(o.value)} value={o.value} data-id="element-420" data-mp="38q9bl4n15k74">{o.label}</option>)}
      </select>
    </div>;
  return <div className="space-y-4" data-id="element-421" data-mp="3crcvc28780dm">
      {selectRow('f-brand', 'Marca', filters.brand, brands.map(b => ({
      label: b.name,
      value: b.id
    })), 'brand')}
      {selectRow('f-model', 'Modelo', filters.model, models.map(m => ({
      label: m,
      value: m
    })), 'model')}
      {selectRow('f-segment', 'Segmento', filters.segment, segments.map(s => ({
      label: s,
      value: s
    })), 'segment')}
      {selectRow('f-body', 'Tipo de carrocería', filters.body, bodyTypes.map(s => ({
      label: s,
      value: s
    })), 'body')}
      {selectRow('f-price', 'Precio de contado', filters.maxPrice, priceBudgets, 'maxPrice', true)}
      {selectRow('f-monthly', 'Presupuesto mensual (cuota)', filters.maxMonthly, monthlyBudgets, 'maxMonthly', true)}
      {selectRow('f-down', 'Anticipo disponible', filters.maxDown, downBudgets, 'maxDown', true)}
      {selectRow('f-term', 'Plazo', filters.term, termOptions.map(t => ({
      label: `${t} meses`,
      value: t
    })), 'term', true)}
      <button type="button" onClick={() => onChange({
      ...emptyFilters,
      sort: filters.sort
    })} className="btn btn-silver w-full" data-id="element-422" data-mp="3pgmrh4081lm7">
        Limpiar filtros
      </button>
    </div>;
}